<template>
  <div class="form-header">
    <h1>{{ title }}</h1>
    <p>{{ description }}</p>
  </div>
</template>
<script>
export default {
  name: 'FormHeader',
  props: {
    title: String,
    description: String
  }
}
</script>
<style lang="scss" scoped>
.form-header {
  h1 {
    font-style: normal;
    font-weight: 500;
    font-size: 32px;
    line-height: 36px;
    color: #7A153C;
    margin-bottom: 16px;
  }
  p {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    color: #616E7C;
    max-width: 454px;
  }
}
</style>